import galleryImg01 from "../../assest/images/gallery-01.jpg";
import galleryImg02 from "../../assest/images/gallery-02.jpg";
import galleryImg03 from "../../assest/images/gallery-03.jpg";
import galleryImg04 from "../../assest/images/gallery-04.jpg";
import galleryImg05 from "../../assest/images/gallery-05.jpg";
import galleryImg06 from "../../assest/images/gallery-06.jpg";
import galleryImg07 from "../../assest/images/gallery-07.jpg";

const galleryImages = [
  galleryImg01,
  galleryImg02,
  galleryImg03,
  galleryImg04,
  galleryImg05,
  galleryImg06,
  galleryImg07,
];

export default galleryImages;
